import type { Guide } from '../types';

/**
 * Przewodnik o samym przewodniku (S-21.10-28): jak go włączyć, gdzie lista
 * „Co nowego”, jak działa panel, podświetlenie i slajdy. Nagrywarka robi te
 * zrzuty z widocznym panelem i na końcu, gdy slajdy pozostałych
 * przewodników już są — panel pokazuje wtedy miniaturę.
 */
const openPanel = [
  { kind: 'clickButton', name: 'Profil' },
  { kind: 'click', target: 'guide-whats-new' },
  { kind: 'click', target: 'guide-open-guideOverlay' },
] as const;

export const guide: Guide = {
  flagKey: 'guideOverlay',
  title: 'Przewodnik po zmianach',
  whatItDoes:
    'Mały panel, który prowadzi krok po kroku przez nowe funkcje czekające na decyzję: co funkcja robi, gdzie ją znaleźć i co kliknąć. Przy każdym kroku jest slajd z ekranu i przycisk, który podświetla właściwe miejsce w aplikacji. Panel można przesunąć, zwinąć albo wyłączyć; na ekranie z nową funkcją sam proponuje przewodnik, ale niczego nie wymusza.',
  audience: ['wszyscy użytkownicy'],
  presentationItems: ['S-21.10-28'],
  steps: [
    {
      route: '/',
      target: 'guide-menu-toggle',
      title: 'Włączanie i wyłączanie',
      description:
        'W menu użytkownika (prawy górny róg) pozycja „Przewodnik po zmianach” włącza i wyłącza panel. Wybór pamięta przeglądarka osobno dla każdego konta.',
      action: 'Kliknij swoją nazwę w prawym górnym rogu, potem „Przewodnik po zmianach”.',
      recorder: { account: 'ftl', actions: [{ kind: 'clickButton', name: 'Profil' }] },
    },
    {
      route: '/',
      target: 'guide-whats-new-dialog',
      title: 'Co nowego',
      description:
        'Lista przewodników po funkcjach, które widzisz w tej wersji aplikacji — z pozycją prezentacji, krótkim opisem i znacznikiem, czy przewodnik był już oglądany.',
      action: 'W menu użytkownika kliknij „Co nowego”, potem „Pokaż przewodnik” przy wybranej funkcji.',
      recorder: {
        account: 'ftl',
        actions: [
          { kind: 'clickButton', name: 'Profil' },
          { kind: 'click', target: 'guide-whats-new' },
        ],
        showGuidePanel: true,
      },
    },
    {
      route: '/',
      target: 'guide-panel',
      title: 'Panel przewodnika',
      description:
        'Panel pokazuje nazwę funkcji i pozycję prezentacji, „Co to robi”, bieżący krok z podpowiedzią, co kliknąć, i miniaturę slajdu. Przesuwasz go, chwytając za pasek tytułu; „–” zwija go do paska u dołu ekranu, Esc robi to samo.',
      action: 'Przeciągnij panel za pasek tytułu w miejsce, w którym nie zasłania pracy.',
      recorder: { account: 'ftl', actions: openPanel, showGuidePanel: true },
    },
    {
      route: '/',
      target: 'guide-show-on-screen',
      title: 'Pokaż na ekranie',
      description:
        'Przycisk podświetla element, o którym mówi krok, i przewija do niego ekran. Gdy krok jest na innym ekranie, przycisk tam prowadzi; gdy dotyczy konkretnego zlecenia, otwiera listę, z której je wybierzesz.',
      action: 'Kliknij „Pokaż na ekranie”, a potem „Dalej”, żeby przejść do następnego kroku.',
      recorder: { account: 'ftl', actions: openPanel, showGuidePanel: true },
    },
    {
      route: '/',
      target: 'guide-slide',
      title: 'Slajdy z ekranu',
      description:
        'Slajdy nagrywamy na danych pokazowych przed każdym wdrożeniem na środowisko akceptacyjne, więc odpowiadają aktualnej wersji. Klik w miniaturę otwiera duży podgląd; strzałki na klawiaturze przewijają slajdy, Esc zamyka.',
      action: 'Kliknij miniaturę slajdu albo „Powiększ”.',
      recorder: { account: 'ftl', actions: openPanel, showGuidePanel: true },
    },
    {
      route: '/feature-flags',
      target: 'guide-flag-button-*',
      title: 'Przewodnik przy decyzji o funkcji',
      description:
        'Na ekranie „Przełączniki funkcji” przy każdej funkcji z przewodnikiem jest przycisk „Przewodnik” — otwiera panel na pierwszym kroku tej funkcji, zanim zapiszesz decyzję.',
      action: 'Otwórz „Przełączniki funkcji” i kliknij „Przewodnik” przy wybranej funkcji.',
      recorder: { account: 'admin' },
    },
  ],
};
